import { Component, Input } from '@angular/core';

// The Vorteil/Risiko block, shared by V3CompetitorOverview and V3CompetitorAnalysis so the two
// can never show different copy or drift in styling. See CLAUDE.md.
@Component({
  selector: 'app-v3-competitor-highlights',
  standalone: true,
  templateUrl: './v3-competitor-highlights.html',
  styleUrl: './v3-competitor-highlights.scss',
})
export class V3CompetitorHighlights {
  @Input() desktop = false;
  @Input() advantage: string | null = null;
  @Input() risk: string | null = null;
}
